/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type IncentivationSourceType = typeof IncentivationSourceType[keyof typeof IncentivationSourceType];


export const IncentivationSourceType = {
  ManualActionIncentivationSource: 'ManualActionIncentivationSource',
} as const;
